
import { $t as lang } from '@/Tool'
import { loginOut } from '@/Tool/LoginSet'
import { defineComponent, computed } from 'vue'
import { ElMessageBox } from 'element-plus'
import { ElMessageBoxOptions } from 'element-plus/packages/message-box/src/message-box.type'
import vuex from '@/store'
import SwitchSkin from './SwitchSkin.vue'

export default defineComponent({
  components: { SwitchSkin },
  props: ['isCollapse'],
  setup() {
    const username = computed(() => vuex.state.user && vuex.state.user.info?.username)
    async function logout() {
      try {
        await ElMessageBox.confirm(lang('mainTip.logout.content'), lang('mainTip.logout.title'), {
          confirmButtonText: lang('mainTip.logout.confirm'),
          cancelButtonText: lang('mainTip.logout.cancel'),
          type: 'warning',
        } as ElMessageBoxOptions)
        await loginOut(vuex.state.user.orgid as number)
      } catch (e) {
        console.log(e)
      }
    }

    return {
      username,
      logout,
      lang,
    }
  },
})
